import { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";

export function useCalculateExtraDiscount(
  cartSkuItems,
  isPending,
  createdFingerPrint,
  isDiscountValid,
) {
  //  const history = useHistory();
  /* Calculate the discount loss for user that occurs because most of the discounted product is in the first index of cart array. 
  When most discounted product first in the array, discount is not applied. */
  const [discountCompansation, setDiscountCompansation] = useState(0);
  // const [runOnce, setRunOnce] = useState(true);
  const [prevDiscount, setPrevDiscount] = useState(0);
  const [extraDiscountAmount, setExtraDiscountAmount] = useState(0);
  const stopDiscount = sessionStorage.getItem("stopDiscount"); // If an item is removed from cart discount will not be recalculated in CALCULATE EXTRA DISCOUNT headlined useEffect

  useEffect(() => {
    if (stopDiscount) {
      setExtraDiscountAmount(0);
    }
  }, [stopDiscount]);

  // CALCULATE EXTRA DISCOUNT
  useEffect(() => {
    if (
      cartSkuItems?.length > 0 &&
      isPending?.isTherePending === "NOTYET" &&
      stopDiscount !== "true" &&
      !isDiscountValid
    ) {
      // 5% DISCOUNT ROUNDED TO 10S
      const makeTheMostOfTheDiscountForCustomer = Math.ceil(
        Math.ceil(cartSkuItems[0]?.priceForOne / 200) * 10,
      );

      // DO NOT POP EXTRA DISCOUNT IF ALREADY SHOWN OR PASSED MORE THAN 36 HOURS AFTER FIRST VISIT
      const currentDiscountForCustomer =
        createdFingerPrint?.isExtraDiscountShown ||
        createdFingerPrint?.passedHoursAfterFirstVisit > 72
          ? makeTheMostOfTheDiscountForCustomer
          : 0;
      // IF EXTRA DISCOUNT AMOUNT IS 0 THAN DELETE LOCAL STORAGE
      if (
        makeTheMostOfTheDiscountForCustomer - currentDiscountForCustomer ===
        0
      ) {
        localStorage.removeItem("extraDiscount");
        setDiscountCompansation(false);
      }

      if (
        makeTheMostOfTheDiscountForCustomer - currentDiscountForCustomer !==
          0 &&
        cartSkuItems.length > 0
      ) {
        const discountAmount =
          makeTheMostOfTheDiscountForCustomer - currentDiscountForCustomer;

        const storedDiscountInfo = JSON.parse(
          localStorage.getItem("extraDiscount"),
        );

        if (storedDiscountInfo) {
          setPrevDiscount(Number(storedDiscountInfo.discountAmount).toFixed(2));
        }

        if (
          !storedDiscountInfo ||
          Number(storedDiscountInfo.discountAmount) !== discountAmount
        ) {
          setDiscountCompansation(
            Number(
              makeTheMostOfTheDiscountForCustomer - currentDiscountForCustomer,
            ).toFixed(2),
          );

          // setRunOnce(false);
        } else {
          setDiscountCompansation(false);
        }

        localStorage.setItem(
          "extraDiscount",
          JSON.stringify({
            sku:
              cartSkuItems &&
              cartSkuItems.length > 1 &&
              cartSkuItems[cartSkuItems.length - 1].price === 0
                ? cartSkuItems[cartSkuItems.length - 2].sku
                : cartSkuItems[cartSkuItems.length - 1].sku,
            discountAmount: discountAmount,
          }),
        );
      }
    }
  }, [
    cartSkuItems,
    cartSkuItems.length,
    isPending?.isTherePending,
    createdFingerPrint?.isExtraDiscountShown,
    createdFingerPrint?.passedHoursAfterFirstVisit,
    stopDiscount,
    isDiscountValid,
  ]);

  // GET extraDiscount LOCAL STORAGE

  useEffect(() => {
    const storage = JSON.parse(localStorage.getItem("extraDiscount"));

    if (storage && /*cartSkuItems.length > 1*/ cartSkuItems.length > 0) {
      setExtraDiscountAmount(Number(storage.discountAmount.toFixed(2)));
    }
  }, [cartSkuItems]);

  return {
    discountCompansation: Number(discountCompansation),
    prevDiscount: Number(prevDiscount),
    extraDiscountAmount: stopDiscount ? 0 : extraDiscountAmount,
  };
}
